import createLucideIcon from '../createLucideIcon';

const Sailboat = createLucideIcon('SailboatIcon', [
  ['path', { d: 'M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z', key: '1404fh' }],
  ['path', { d: 'M21 14 10 2 3 14h18Z', key: '1nzg7v' }],
  ['path', { d: 'M10 2v16', key: '1labyt' }],
]);

export default Sailboat;
